import { render, staticRenderFns } from "./CmsGeneralLocalization.vue?vue&type=template&id=1e8be9f8&scoped=true&"
import script from "./CmsGeneralLocalization.vue?vue&type=script&lang=js&"
export * from "./CmsGeneralLocalization.vue?vue&type=script&lang=js&"
import style0 from "./CmsGeneralLocalization.vue?vue&type=style&index=0&id=1e8be9f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8be9f8",
  null
  
)

export default component.exports